var map = {
	"./Chinese-literature.svg": 158,
	"./bookmark.svg": 159,
	"./calculus.svg": 160,
	"./document.svg": 161,
	"./elementary-math.svg": 162,
	"./higher-mathematics.svg": 163,
	"./loadding-logo.svg": 164,
	"./logo.svg": 165,
	"./mock-exam.svg": 166,
	"./photo.svg": 167,
	"./secondary-math.svg": 168,
	"./trash.svg": 169,
	"./workbook.svg": 170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;